import { getCurrentUser, loggedIn } from "./auth";
import http from "./http";

export async function logTime(time) {
  let formData = new FormData();
  formData.append("time_used", time);
  if (loggedIn()) formData.append("email", getCurrentUser());

  const { data: response } = await http.post("/log", formData, {
    showLoader: false,
  });
  return response;
}

export async function checkTimeLimit() {
  let formData = new FormData();
  if (loggedIn()) {
    formData.append("email", getCurrentUser());
  }

  const { data: response } = await http.post("/log/checkTimelimit", formData);
  return response;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  logTime,
  checkTimeLimit,
};
